<div class="card width100 logo">
    <a target=_blank href="https://dbs.com.sg"><img class="logowidth" src="assets/images/logo.jpg"></a>
</div>
<div class="card width100 hero">
</div>
